
export enum NotificationStatusEnum {
    unread,
    read
}

export class Notification {
    body: string;
    details: string;
    readStatus: NotificationStatusEnum;
    readStatusDescription: string;
    sendDate: string;
    messageID: number;
    attendence: string;
} 